module.exports = __webpack_public_path__ + "static/media/secao-5-bg.fb581d36.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/secao-5-bg.png
// module id = 941
// module chunks = 7